/* eslint-disable no-unused-vars */

import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from 'react-router';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { decode } from 'jsonwebtoken';
import { isEmpty } from 'lodash';
import {
  selectApplication,
  selectApplicationType,
} from '../store/selectors/applicationSelectors';
import {
  selectIsReCaptchaEnabled,
  selectSettings,
} from '../store/selectors/settingsSelectors';
import {
  createPlainUser,
  createUser,
  logoutUser,
  refreshTokens,
} from '../store/actions/user/userActions';
import { PAGES } from '../constants/pages';
import BaseLayoutCta from '../components/BaseLayoutCta/BaseLayoutCta';
import {
  FormContainer,
  FormWrap,
} from '../components/FormContainer/FormContainer';
import {
  ACCOUNT_TYPES,
  APPLICATION_TYPE,
  APPLICATION_TYPE_STRING_KEYS,
  BASIC_ACCOUNT_UPGRADE_TYPES,
  REGISTRATION_FLOW_TYPES,
} from '../util/constants';
import {
  APPLICATION_TYPE as APP_TYPE,
  APPLICATION_TYPE_STORAGE,
  ACCOUNT_TYPE,
  EMAIL,
  REGISTRATION_FLOW_TYPE,
  SIGNIFYD_SESSION_ID,
  SALES_ASSISTED_QUERY_DATA,
} from '../constants/sessionStorage';
import {
  retrieveFromSessionStorage,
  storeInSessionStorage,
} from '../util/helpers/sessionStorageHelper';
import { isAipRegistrationFlow } from '../util/helpers/registrationFlowTypeHelper';
import useGtmHook from '../util/hooks/useGtmHook';
import { ACCOUNT_STEP_VIEW, APPLICATION_STARTED } from '../util/gtmEvents';

import BaseLayout from '../components/BaseLayout';
import { Heading } from '../components/Heading';
import InputText from '../components/Fields/InputText';
import PasswordInput from '../components/Fields/PasswordInput';
import { getValidationSchema } from '../util/helpers/getValidationSchema';
import useTrackingDetails from '../hooks/useTrackingDetails';
import { JWT_TOKEN } from '../constants/localStorage';
import {
  createApplication,
  getApplication,
} from '../store/actions/application/applicationActions';
import ExistingApplicationModal from '../components/Modals/ExistingApplicationModal/ExistingApplicationModal';
import {} from '../constants/accountTypes';
import useChoosenApplicationTypeData from '../hooks/useChoosenApplicationTypeData';
import { getTokens } from '../util/helpers/getTokensHelper';
import { applicationTypeStringHelper } from '../util/helpers/applicationTypeStringHelper';
import config from '../config';
import Paragraph from '../components/Paragraph/Paragraph';
import { WelcomeLoginLink } from './WelcomeFluent';
import loadSignifydDeviceFingerprintScript from '../signifydDeviceFingerprint';
import useQuery from '../util/hooks/useQuery';
import useGtmStepHook from '../util/hooks/useGtmStepHook';
import { gtmStepHelper } from '../util/helpers/gtmHelper';

const CreateAccount = () => {
  const { ApplicationType, AccountType } = useSelector(selectApplicationType);
  const registrationFlowType = retrieveFromSessionStorage(
    REGISTRATION_FLOW_TYPE,
  );
  const isAipFlow = isAipRegistrationFlow(registrationFlowType);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { gtmEvent } = useGtmHook();
  const { gtmStepEvent } = useGtmStepHook();
  const { email } = useQuery();
  const { TrackingDetails } = useTrackingDetails();
  const { RegistrationUrl } = useSelector(selectSettings);
  const [isExistingModalOpen, setIsExistingModalOpen] = useState(false);
  const Application = useSelector(selectApplication);
  const { data } = useChoosenApplicationTypeData();
  const { JwtToken, JwtRefreshToken } = getTokens();
  const reCaptchaRef = React.createRef();
  const isReCaptchaEnabled = useSelector(selectIsReCaptchaEnabled);
  const settings = useSelector(selectSettings);
  const { BrokerName } = settings;
  const salesAssistedQueryData = retrieveFromSessionStorage(
    SALES_ASSISTED_QUERY_DATA,
  );
  const accountTypeFromStorage = retrieveFromSessionStorage(ACCOUNT_TYPE);
  const applicationTypeFromStorage = retrieveFromSessionStorage(APP_TYPE);
  const formValidationSchema = yup.object({
    ...getValidationSchema({
      fields: ['Email', 'Password'],
    }),
  });

  const { handleSubmit, control, setError, getValues } = useForm({
    resolver: yupResolver(formValidationSchema),
    defaultValues: {
      Email: email
        ? decodeURIComponent(email)
        : retrieveFromSessionStorage(EMAIL) &&
          retrieveFromSessionStorage(EMAIL),
    },
  });

  // useEffect(() => {
  //   if (
  //     !applicationTypeFromStorage ||
  //     (!!applicationTypeFromStorage &&
  //       [
  //         APPLICATION_TYPE_STRING_KEYS.IRA,
  //         APPLICATION_TYPE_STRING_KEYS.UTMA,
  //       ].includes(applicationTypeFromStorage) &&
  //       !accountTypeFromStorage)
  //   ) {
  //     return history.push(PAGES.CREATE_APPLICATION.MAIN);
  //   }
  // });

  useEffect(() => {
    const {
      ApplicationType,
      ApplicationStep,
      AccountUid,
      AccountUpgradeType,
    } = Application;

    if (isEmpty(Application)) {
      return;
    }
    const isUpgrade =
      AccountUpgradeType === BASIC_ACCOUNT_UPGRADE_TYPES.IN_PROCESS;
    if (
      (ApplicationStep &&
        ApplicationStep === '/kyc/verification' &&
        isUpgrade) ||
      ApplicationStep === '/kyc/done'
    ) {
      startNewApplication();
      return;
    }
    if (
      ApplicationStep
      //  ||
      // (ApplicationType &&
      //   (!AccountUpgradeType ||
      //     AccountUpgradeType === BASIC_ACCOUNT_UPGRADE_TYPES.IN_PROCESS))
    ) {
      setIsExistingModalOpen(true);
      return;
    }
    if (AccountUid) {
      history.push(PAGES.LOADING);
    }
    const currentAccountType = retrieveFromSessionStorage(ACCOUNT_TYPE);
    const currentApplicationType = retrieveFromSessionStorage(
      APPLICATION_TYPE_STORAGE,
    );
    const applicationType = APPLICATION_TYPE[ApplicationType];

    if (!applicationType) {
      history.push(PAGES.LOADING);
    }

    if (!isExistingModalOpen) {
      if (
        (ApplicationStep &&
          ApplicationStep === '/kyc/verification' &&
          isUpgrade) ||
        ApplicationStep === '/kyc/done'
      ) {
        startNewApplication();
        return;
      }
      if (currentApplicationType !== applicationType) {
        setIsExistingModalOpen(true);
        return;
      }

      const applicationTypeString = applicationTypeStringHelper(
        ApplicationType,
      );

      if (applicationTypeString) {
        const accountData = Application[applicationTypeString];

        if (accountData && applicationTypeString && accountData?.AccountType) {
          const accountType =
            ACCOUNT_TYPES[applicationTypeString][accountData?.AccountType];

          if (currentAccountType !== accountType) {
            setIsExistingModalOpen(true);
            return;
          }
        }
      }
      history.push(PAGES.LOADING);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Application, history, registrationFlowType, AccountType]);

  const onRedirection = () => {
    const email = getValues('Email');
    window.location.href = `${RegistrationUrl}/r/start?email=${encodeURIComponent(
      email,
    )}`;
  };

  const onSubmit = async (data) => {
    const onSuccess = () => {
      gtmEvent(APPLICATION_STARTED);

      const JwtToken = retrieveFromSessionStorage(JWT_TOKEN);
      if (!JwtToken) {
        return;
      }
      const { ApplicationUid } = decode(JwtToken);

      if (JwtToken) {
        gtmStepHelper({
          gtmStepEvent,
          eventName: ACCOUNT_STEP_VIEW,
          stepLabel: 'Create Account',
          accountId: ApplicationUid,
        });
      }

      dispatch(getApplication({ data: { ApplicationUid } }));
    };

    storeInSessionStorage(EMAIL, data.Email);
    const onError = (errorMessage) => {
      setError('Email', errorMessage);
    };

    if (isReCaptchaEnabled) {
      const token = await reCaptchaRef.current.executeAsync();
      reCaptchaRef.current.reset();
      dispatch(
        isAipFlow
          ? createUser({
              data: {
                ...data,
                TrackingDetails,
                RecaptchaToken: token,
                applicationType: APPLICATION_TYPE[1],
                accountType: '',
                registrationFlowType: REGISTRATION_FLOW_TYPES.AIP,
              },
              onSuccess,
              onError,
              onRedirection,
            })
          : createPlainUser({
              data: {
                ...data,
                TrackingDetails,
                RecaptchaToken: token,
                registrationFlowType: REGISTRATION_FLOW_TYPES.REGULAR,
              },
              onSuccess,
              onError,
              onRedirection,
            }),
      );
      return;
    }

    dispatch(
      isAipFlow
        ? createUser({
            data: {
              ...data,
              TrackingDetails,
              applicationType: APPLICATION_TYPE[1],
              accountType: '',
              registrationFlowType: REGISTRATION_FLOW_TYPES.AIP,
            },
            onSuccess,
            onError,
            onRedirection,
          })
        : createPlainUser({
            data: {
              ...data,
              TrackingDetails,
              registrationFlowType: REGISTRATION_FLOW_TYPES.REGULAR,
            },
            onSuccess,
            onError,
            onRedirection,
          }),
    );
  };

  const continueApplication = () => {
    setIsExistingModalOpen(false);
    history.push(PAGES.LOADING);
    document.body.style.overflow = 'unset';

    loadSignifydDeviceFingerprintScript();
    const script = document.getElementById('sig-api');
    storeInSessionStorage(SIGNIFYD_SESSION_ID, script.dataset.orderSessionId);
    // eslint-disable-next-line no-console
    console.log(
      'NEW CREATED SIGNIFYD_SESSION_ID:',
      script.dataset.orderSessionId,
    );
  };

  const startNewApplication = () => {
    const onSuccess = () => {
      dispatch(
        refreshTokens({
          data: {
            JwtToken,
            JwtRefreshToken,
          },
          onSuccess: () => {
            setIsExistingModalOpen(false);
            history.push(PAGES.LOADING);
            document.body.style.overflow = 'unset';
          },
        }),
      );
    };
    const { ApplicationUid } = decode(JwtToken);
    const params = {
      registrationFlowType: isAipFlow
        ? REGISTRATION_FLOW_TYPES.AIP
        : REGISTRATION_FLOW_TYPES.REGULAR,
    };
    dispatch(
      createApplication({
        data,
        onSuccess,
        ApplicationUid,
        params,
      }),
    );
  };

  const onClose = () => {
    setIsExistingModalOpen(false);
    dispatch(logoutUser());
  };

  const getPreviousPathViaApplicationType = () => {
    if (isAipFlow) {
      return PAGES.AIP;
    }

    switch (ApplicationType) {
      case APPLICATION_TYPE[1]:
        return PAGES.CREATE_APPLICATION.STANDARD.MAIN;

      case APPLICATION_TYPE[2]:
        return PAGES.CREATE_APPLICATION.STANDARD.MAIN;

      case APPLICATION_TYPE[3]:
        return PAGES.CREATE_APPLICATION.RETIREMENT.MAIN;

      case APPLICATION_TYPE[4]:
        return PAGES.CREATE_APPLICATION.STANDARD.MAIN;

      case APPLICATION_TYPE[5]:
        return PAGES.CREATE_APPLICATION.UTMA.MAIN;

      default:
        break;
    }
  };
  return (
    <BaseLayout previousPath={getPreviousPathViaApplicationType()}>
      <Helmet>
        <title>
          {t('loginFluent.titleTagProgress', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading fontWeight={700} mb={28}>
        {t('loginFluent.progress')}
      </Heading>
      <FormWrap>
        <FormContainer maxWidth={344}>
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState }) => (
              <InputText
                label={t('loginFluent.emailAddress')}
                type="email"
                {...field}
                {...fieldState}
                autoFocus
                autocomplete="email username"
              />
            )}
            name="Email"
            defaultValue=""
          />
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState }) => (
              <PasswordInput
                label={t('loginFluent.createPassword')}
                {...field}
                {...fieldState}
                autocomplete="new-password"
              />
            )}
            name="Password"
            defaultValue=""
          />
          {isReCaptchaEnabled && (
            <ReCAPTCHA
              ref={reCaptchaRef}
              sitekey={config.recaptcha.siteKey}
              size="invisible"
            />
          )}
        </FormContainer>
        <BaseLayoutCta
          buttonProps={{
            type: 'submit',
            title: t('loginFluent.continue'),
            onClick: handleSubmit(onSubmit),
          }}
        />
      </FormWrap>
      <ExistingApplicationModal
        isOpen={isExistingModalOpen}
        onClose={onClose}
        continueApplication={continueApplication}
        startNewApplication={startNewApplication}
      />
    </BaseLayout>
  );
};

export default CreateAccount;
